import { GetFulfillmentOrderDetailsForAdminState } from './getFulfillmentOrderDetailsForAdmin.types'

const initialState: GetFulfillmentOrderDetailsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
